import AOS from "aos";
import "aos/dist/aos.css";
import React, { useState, useEffect } from "react";
import { CgWebsite } from "react-icons/cg";
import { MdOutlineMiscellaneousServices } from "react-icons/md";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../assets/css/Portfolio.css";
import { Container, Row, Col, Card } from "react-bootstrap";
import Footer from "../Footer/Footer";
import Card_6 from "../../assets/image/Service/servicecard-6.jpg";
import Card_7 from "../../assets/image/Service/servicecard-7.jpg";
import PortOne from "../../assets/image/Portfolio/portfolio-1.jpg";
import PortTwo from "../../assets/image/Portfolio/portfolio-2.jpg";
import PortThree from "../../assets/image/Portfolio/portfolio-3.jpg";
import { Helmet, HelmetProvider } from "react-helmet-async";
import data from "../../Meta/Meta_ApiUrl";

const Portfolio = () => {
  const [meta, setMeta] = useState({});
  const [activeTab, setActiveTab] = useState("drone-projects");

  useEffect(() => {
    const metaData = data[0]?.services_page_Portfolio;
    if (metaData) setMeta(metaData);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  // ✅ Drone Projects (NEW)
  const droneProjects = [
    {
      title: "Aerial Survey & Mapping",
      image: PortOne,
      desc: "High-precision drone-based land surveying and GIS mapping for construction and infrastructure projects.",
    },
    {
      title: "Industrial Inspection",
      image: PortTwo,
      desc: "Drone inspections for solar panels, wind turbines, power lines, and telecom towers ensuring safety and efficiency.",
    },
    {
      title: "Agriculture Drone Solutions",
      image: PortThree,
      desc: "Smart farming solutions including crop monitoring, spraying, and precision agriculture analytics.",
    },
  ];

  // ✅ Website Projects
  const webdev = [
    {
      title: "E-Commerce Platform",
      image: Card_6,
      desc: "Scalable e-commerce solution with secure payments, product management, and user-friendly interface.",
    },
    {
      title: "Tours & Travel Website",
      image: Card_7,
      desc: "Modern travel booking platform with dynamic packages, booking system, and responsive UI.",
    },
  ];

  return (
    <HelmetProvider>
      <Helmet>
        <title>
          {meta?.title ||
            "Services-Portfolio - SHIV NXTGEN TECHNOLOGIES PRIVATE LIMITED"}
        </title>
        <meta
          name="description"
          content={meta?.meta?.meta1?.content || "Our portfolio of projects."}
        />
      </Helmet>

      <div>
        {/* Banner */}
        <div className="position-relative portfolio-bg bg-light text-dark overflow-hidden min-vh-50 d-flex align-items-center">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <nav className="mb-4">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a href="/" className="text-white fw-bold text-decoration-none">
                        Home
                      </a>
                    </li>
                    <li className="text-white fw-bold breadcrumb-item">
                      Portfolio
                    </li>
                  </ol>
                </nav>
                <h3 className="display-5 fw-bold">Portfolio</h3>
              </div>
            </div>
          </div>
        </div>

        {/* Tabs */}
        <div className="container text-center py-5">
          <div className="d-flex justify-content-center gap-3 flex-wrap mb-4">

            {/* Drone */}
            <button
              className={`btn fw-semibold ${
                activeTab === "drone-projects"
                  ? "btn-red text-white"
                  : "btn-outline-secondary"
              }`}
              onClick={() => setActiveTab("drone-projects")}
            >
              Drone Projects <MdOutlineMiscellaneousServices className="ms-2" />
            </button>

            {/* Website */}
            <button
              className={`btn fw-semibold ${
                activeTab === "website-development"
                  ? "btn-red text-white"
                  : "btn-outline-secondary"
              }`}
              onClick={() => setActiveTab("website-development")}
            >
              Website Development <CgWebsite className="ms-2" />
            </button>
          </div>

          <div className="border-top pt-4">

            {/* ✅ DRONE PROJECTS */}
            {activeTab === "drone-projects" && (
              <Container>
                <h2 className="mb-5 fw-bold">Our Drone Solutions</h2>
                <Row className="g-4">
                  {droneProjects.map((item, index) => (
                    <Col md={4} key={index}>
                      <Card className="h-100 shadow border-0">
                        <Card.Img
                          src={item.image}
                          style={{ height: "200px", objectFit: "cover" }}
                        />
                        <Card.Body>
                          <Card.Title className="fw-bold">
                            {item.title}
                          </Card.Title>
                          <Card.Text>{item.desc}</Card.Text>
                        </Card.Body>
                      </Card>
                    </Col>
                  ))}
                </Row>
              </Container>
            )}

            {/* ✅ WEBSITE */}
            {activeTab === "website-development" && (
              <Container>
                <h2 className="mb-5 fw-bold">Our Web Development</h2>
                <Row className="g-4 justify-content-center">
                  {webdev.map((item, index) => (
                    <Col md={6} key={index}>
                      <Card className="h-100 shadow border-0">
                        <Card.Img
                          src={item.image}
                          style={{ height: "200px", objectFit: "cover" }}
                        />
                        <Card.Body>
                          <Card.Title className="fw-bold">
                            {item.title}
                          </Card.Title>
                          <Card.Text>{item.desc}</Card.Text>
                        </Card.Body>
                      </Card>
                    </Col>
                  ))}
                </Row>
              </Container>
            )}

          </div>
        </div>

        <Footer />
      </div>
    </HelmetProvider>
  );
};

export default Portfolio;